import { css } from 'styled-components';
import { ColorAddiPrimaryActive, ColorAddiPrimaryHover, ColorAddiPrimaryInactive } from "@addi/foundation/dist/web/colors";
export const SecondaryButtonStyles = css `
    color: ${ColorAddiPrimaryActive};
    border: solid 2px ${ColorAddiPrimaryActive};
    background-color: transparent;

    &:hover {
        color: ${ColorAddiPrimaryHover};
        border-color: ${ColorAddiPrimaryHover};

        svg {
            color: ${ColorAddiPrimaryHover};
        }
    }

    &:active {
        color: ${ColorAddiPrimaryHover};
    }

    &:focus {
        color: ${ColorAddiPrimaryHover};
        border-color: ${ColorAddiPrimaryHover};
        background-color: ${ColorAddiPrimaryInactive};

        svg {
            color: ${ColorAddiPrimaryHover};
        }
    }

    &[disabled] {
        cursor: default;
        pointer-events: none;
        color: ${ColorAddiPrimaryInactive};
        border-color: ${ColorAddiPrimaryInactive};

        svg {
            color: ${ColorAddiPrimaryInactive};
        }
    }

    svg {
        color: ${ColorAddiPrimaryActive};
    }
`;
//# sourceMappingURL=secondary-button-styles.js.map